<template>
    <div class="row mt-3">
        <div class="col-xl-3 col-lg-4">
            <vueCustomScrollbar class="b-item-scroll">
                <transition-group type="transition">
                    <ElectronicLectureCollapse :item="item" v-for="(item, index) of listLessonPlaning" :key="index" @handleToggleCollapse="handleToggleCollapse">
                        <template v-slot:chapter>
                            <b-collapse class="mt-1" :visible="item.isCollapse">
                                <vueCustomScrollbar class="b-chapter-scroll">
                                    <ChapterCollapse v-for="(chapter, chapterIndex) of item.listChapterClassSchool" 
                                        :item="chapter"
                                        :indexElectronicLecture="index" 
                                        :key="chapterIndex" 
                                        @handleToggleCollapse="handleToggleCollapseChapter">
                                        <template v-slot:post>
                                            <b-collapse class="mt-1" :visible="chapter.isCollapse">
                                                <PostCollapse v-for="(post, indexPost) of chapter.listPostClassSchool" 
                                                    :item="post"
                                                    :key="indexPost" 
                                                    :indexElectronicLecture="index" 
                                                    :indexChapter="chapterIndex" 
                                                    @handleToggleCollapsePost="handleToggleCollapsePost">
                                                    <template v-slot:lecture>
                                                        <b-collapse class="mt-1" :visible="post.isCollapse">
                                                            <LectureCollapse v-for="(document, indexDocument) of post.listDocumentClassSchool" 
                                                                :isDisabledCheckbox="true" 
                                                                :item="document"  
                                                                :key="indexDocument"
                                                                @handleclick="handleOnViewDocument"
                                                            />
                                                        </b-collapse>
                                                    </template>
                                                </PostCollapse>
                                            </b-collapse>
                                        </template>
                                    </ChapterCollapse>
                                </vueCustomScrollbar>
                            </b-collapse>
                        </template>
                    </ElectronicLectureCollapse>
                </transition-group>
                <div class="mt-2 p-2">
                    <div @click="handleToggleCollapseFile" class="name-files display-flex-center">
                        <strong>Tài liệu đính kèm</strong>
                    </div>
                    <b-collapse class="mt-1" :visible="isCollapseFile">
                        <div class="display-flex-center p-1" v-for="(item, index) of listDataFile" :key="index">
                            <a href="javascripts:;" @click="handleOnViewFile(item)"> 
                                {{ item.name }}
                            </a>
                        </div>
                    </b-collapse>
                </div>
                <div class="mt-2 p-2">
                    <div @click="handleToggleCollapseNVHT" class="name-files display-flex-center">
                        <strong>Nhiệm vụ học tập</strong>
                    </div>
                    <b-collapse class="mt-1" :visible="isCollapseLearningTask">
                        <div class="display-flex-center p-1" v-for="(item, index) of listLearningTaskLesson" :key="index">
                            <a href="javascripts:;" @click="handleOnTask(item)"> 
                                {{ item.name }}
                            </a>
                        </div>
                    </b-collapse>
                </div>
            </vueCustomScrollbar>
        </div>
        <div class="col-xl-9 col-lg-8">
            <vueCustomScrollbar class="content">
                <div class="view-document">
                    <ViewQuestion :listQuestion="listQuestion" :learningTaskId="learningTaskId" v-if="isShowQuestion" />
                    <ViewDocument v-if="isShowDocument" :item="itemDocumentSelected" />
                    <ViewFile v-if="isShowFile" :path="pathSelected" />
                </div>
            </vueCustomScrollbar>
        </div>
    </div>
</template>
<script>
import moment from "moment"
import vueCustomScrollbar from 'vue-custom-scrollbar'
import ChapterCollapse from './ChapterCollapse'
import PostCollapse from './PostCollapse'
import LectureCollapse from './LectureCollapse'
import ElectronicLectureCollapse from "./ElectronicLectureCollapse.vue"
import { GetListElectronicLecture } from './../../_api/LessonClassSchoolServices'
import { PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN } from './../../constants/constants_enum'
import ViewDocument from './../../_components/ViewDocument'
import { getListLearningTaskLesson, getListQuestion } from './../../_api/learningTask'
import { listFileClassSchool, listFileElectronicByLessonPlaning } from './../../_api/fileClassSchoolServices'
import { saveDocumentUserClassSchool } from './../../_api/documentUserClassSchoolServices'
import ViewFile from './../../_components/ViewFile'
import ViewQuestion from './../../_components/ViewQuestion'

export default {
    components:{
        vueCustomScrollbar,
        ChapterCollapse,
        PostCollapse,
        LectureCollapse,
        ElectronicLectureCollapse,
        ViewDocument,
        ViewFile,
        ViewQuestion
    },
    props: {
        listGroupId: {
            type: Number,
            default: 0
        },
        classSchoolId: {
            type: Number,
            default: 0
        },
        lessonClassSchoolId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            listLessonPlaning: [],
            listElectronicLecture: [],
            PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN,
            paramQueryData: {
                classSchoolId: 0,
                id: 0,
                type: PLANING_LESSON_WAREHOUSE,
                keyword: '',
                pageIndex: 1,
                pageSize: 5,
            },
            isShowDocument: false,
            isShowFile: false,
            isShowQuestion: false,
            athSelected: '',
            itemDocumentSelected: null,
            paramQueryDataFile: {
                lessonClassSchoolId: 0,
            },
            listDataFile: [],
            totalRecordsFile: 0,
            listLearningTaskLesson: [],
            learningTaskId: 0,
            listQuestion: [],
            isClickDocument: false,
            isCollapseFile: false,
            isCollapseLearningTask: false,
            pathSelected: ''
        }
    },
    mounted(){
        this.paramQueryData.id = this.paramQueryDataFile.lessonClassSchoolId = this.lessonClassSchoolId
        this.classSchoolId = this.paramQueryData.classSchoolId = this.classSchoolId
        this.getListElectronicLecture()
        this.getDataFile()
        this.getListLearningTask()
    },
    methods:{
        moment,
        formatNumber(value){
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(0);
        },
        handleToggleCollapse(item){
            for (let i = 0; i < this.listLessonPlaning.length; i++) {
                if (this.listLessonPlaning[i].id != item.id) {
                    this.listLessonPlaning[i].isCollapse = false
                }
            }
            item.isCollapse = !item.isCollapse
        },
        handleToggleCollapseChapter(item, index){
            if (this.listLessonPlaning.length > 0) {
                let listChapter = this.listLessonPlaning[index].listChapterClassSchool
                for (let i = 0; i < listChapter.length; i++) {
                    if (listChapter[i].id != item.id) {
                        listChapter[i].isCollapse = false
                    }
                }
            }
            item.isCollapse = !item.isCollapse
        },
        handleToggleCollapsePost(item, indexChapter, indexElectronicLecture){
            if (this.listLessonPlaning.length > 0) {
                let listChapter = this.listLessonPlaning[indexElectronicLecture].listChapterClassSchool
                if (listChapter.length > 0) {
                    let listPost = listChapter[indexChapter].listPostClassSchool
                    for (let i = 0; i < listPost.length; i++) {
                        if (listPost[i].id != item.id) {
                            listPost[i].isCollapse = false
                        }
                    }
                }
            }
            item.isCollapse = !item.isCollapse
        },
        handleToggleCollapseFile() {
            this.isCollapseFile = !this.isCollapseFile
        },
        handleToggleCollapseNVHT() {
            this.isCollapseLearningTask = !this.isCollapseLearningTask
        },
        handleOnViewFile(file) {
            this.viewFile()
            this.pathSelected = file.path
        },
        handleOnTask(item) {
            this.isShowQuestion = false
            this.isClickTask = true
            this.learningTaskId = item.learningTaskId
            this.getListQuestionByLearningTask()
        },
        viewQuestion() {
            this.isShowQuestion = true
            this.isShowDocument = false,
                this.isShowFile = false
        },
        viewFile() {
            this.isShowQuestion = false
            this.isShowDocument = false,
                this.isShowFile = true
        },
        viewDocument() {
            this.isShowQuestion = false
            this.isShowDocument = true,
                this.isShowFile = false
        },
        handleOnViewDocument(isCheck, document) {
            let self = this

            this.viewDocument()

            document.isCheck = true
            this.itemDocumentSelected = document

            let params = {
                lesssonPlaningId: this.paramQueryData.id,
                classSchoolId: this.classSchoolId,
                lessonClassSchoolId: document.lessonClassSchoolId,
                ChapId: document.chapterId,
                postId: document.postId,
                documentId: document.id,
                type: PLANING_LESSON_WAREHOUSE,
                status: 2
            }
            saveDocumentUserClassSchool(params).then(() => {
                // eslint-disable-next-line no-empty

            })
        },
        formatSizeFile(data, to = 'MB') {
            const const_term = 1024;

            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") {
                return (data / const_term).toFixed(3) + "KB";
            } else if (to === "MB") {
                return (data / const_term ** 2).toFixed(3) + "MB";
            } else if (to === "GB") {
                return (data / const_term ** 3).toFixed(3) + "GB";
            } else if (to === "TB") {
                return (data / const_term ** 4).toFixed(3) + "TB";
            } else {
                return "";
            }
        },
        getDataFile() {
            let self = this
            listFileElectronicByLessonPlaning(this.paramQueryDataFile).then(res => {
                if (res && res.data && !res.errors) {
                    self.listDataFile = res.data
                    //self.totalRecordsFile = res.data.paging.totalRecords
                }
            })
        },
        getListElectronicLecture() {
            let self = this
            GetListElectronicLecture(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listLessonPlaning = res.data
                }
            })
        },
        getListLearningTask() {
            let self = this
            getListLearningTaskLesson(self.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    self.listLearningTaskLesson = res.data.list
                    self.totalRecords = res.data.paging.totalRecords

                }
            })

        },

        getListQuestionByLearningTask() {
            let self = this
            let params = {
                lessonClassSchoolId: this.paramQueryData.id,
                classSchoolId: this.classSchoolId,
                learningTaskId: self.learningTaskId
            }
            getListQuestion(params).then(res => {
                if (res && res.data && !res.errors) {
                    self.listQuestion = res.data
                }
                this.viewQuestion()
            })

        },
    }
}
</script>
<style lang="scss" scoped>
.b-item-scroll {
    max-height: 60vh;
    overflow-y: auto;
}
.b-chapter-scroll {
    max-height: 30vh;
    overflow-y: auto;
}
.content {
    //padding: 0.5rem 2rem;
    border: 1px solid #dee2e6;
    border-radius: 0.6rem;
    min-height: 30rem;
}
.icon-edit {
    width: 15px;
    cursor: pointer;
}
.name-files {
    cursor: pointer;
    border-bottom: 1px solid #dee2e6;
}
.view-document {
    height: 30rem;
}
</style>